import { post, get } from "./axios";

interface resTypes<T> {
  code: number;
  msg: string;
  data: T;
}

interface versionTypes {
  downloadUrl: string;
}

export const homeAppCheckVersion = (data: { appKey: any }) => {
  return post<resTypes<versionTypes>>("/assistant/app/check-version", data);
};
